import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => {
  return createStyles({
    root: {
      flexGrow: 1,
    },
  });
});
export default useStyles;
